import React from 'react'
import { Card, CardContent, Box, Typography, Chip, Skeleton } from '@mui/material'
import { Bar } from 'react-chartjs-2'
import { SMBDashboardSummary } from '../../../services/api'

interface ConversationStatsChartProps {
  summary: SMBDashboardSummary | null;
  summaryLoading: boolean;
}

export const ConversationStatsChart: React.FC<ConversationStatsChartProps> = ({ summary, summaryLoading }) => {
  const stats = summary?.conversation_stats
  const totalConvs = (stats?.active ?? 0) + (stats?.inactive ?? 0)
  
  const convChartData = {
    labels: ['Total', 'Active', 'Inactive', 'Qualified'],
    datasets: [
      {
        data: [totalConvs, stats?.active ?? 0, stats?.inactive ?? 0, stats?.qualified ?? 0],
        backgroundColor: ['#6366f1', '#10B981', '#94A3B8', '#F59E0B'],
        borderRadius: 6,
        borderSkipped: false,
        barThickness: 32,
        minBarLength: 5,
      },
    ],
  }

  return (
    <Card sx={{ height: '100%', borderRadius: '16px', border: '1px solid', borderColor: '#F1F5F9', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
      <CardContent sx={{ p: '24px !important' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="h6" fontWeight="bold" sx={{ letterSpacing: '-0.5px', color: '#0F172A' }}>
            Conversation Stats
          </Typography>
          <Chip label="Last 30 Days" size="small" sx={{ bgcolor: '#F8FAFC', color: '#64748B', fontWeight: 600, fontSize: '0.75rem', border: '1px solid #F1F5F9' }} />
        </Box>
        <Typography variant="body2" color="#64748B" sx={{ mb: 3 }}>
          Distribution of all active and inactive threads
        </Typography>
        
        {summaryLoading && !summary ? (
          <Skeleton variant="rectangular" height={260} />
        ) : (
          <Box sx={{ height: 260 }}>
            <Bar
              data={convChartData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                devicePixelRatio: window.devicePixelRatio > 1 ? window.devicePixelRatio : 2,
                plugins: {
                  legend: { display: false },
                  tooltip: {
                    backgroundColor: '#1E293B',
                    padding: 12,
                    titleFont: { size: 14, weight: 600, family: 'Inter, sans-serif' },
                    bodyFont: { size: 14, weight: 500, family: 'Inter, sans-serif' },
                    cornerRadius: 8,
                    displayColors: false,
                    callbacks: {
                      label: (ctx) => `${ctx.parsed.y} conversations`,
                    },
                  },
                },
                scales: {
                  x: { 
                    grid: { display: false },
                    border: { display: false },
                    ticks: { font: { weight: 500, size: 13 }, color: '#64748B' }
                  },
                  y: { 
                    beginAtZero: true, 
                    grid: { color: '#F1F5F9' },
                    border: { display: false, dash: [4, 4] },
                    ticks: { precision: 0, maxTicksLimit: 5, color: '#94A3B8', font: { size: 12, weight: 500 } }
                  },
                },
              }}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  )
}
